export enum GarageStatusEnum {
  INDIVIDUAL = 'INDIVIDUAL',
  ON_SALE = 'ON_SALE',
  CO_OWNER = 'CO_OWNER',
  SOLD = 'SOLD',
  ALL = 'ALL'
}
